export enum PRStatus {
  Pending,
  Approved,
  Rejected,
  InReview,
}

export const getRPRStatusString = (status: PRStatus): string => {
  return PRStatus[status];
};
